import { render, staticRenderFns } from "./JobsList.vue?vue&type=template&id=088b23aa&scoped=true&"
import script from "./JobsList.vue?vue&type=script&lang=js&"
export * from "./JobsList.vue?vue&type=script&lang=js&"
import style0 from "./JobsList.vue?vue&type=style&index=0&id=088b23aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088b23aa",
  null
  
)

export default component.exports